var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configuration-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.selectedAction !== 'configuration-view-all'),expression:"this.$store.state.selectedAction !== 'configuration-view-all'"}],staticClass:"configuration-header"},[_c('h5',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }